module.exports = __webpack_public_path__ + "static/media/set5.7f1ed0cf.png";